import { useFormik } from 'formik';
import { ErrorText } from '../forms/error-text';
import { FormGroup } from '../forms/form-group';
import * as Yup from 'yup';
import styles from './register.module.css';
import { Button } from '../button/button';
import { ButtonTier } from '../button/button.types';
import { ModalContent, close, open } from '../modal/modalSlice';
import { useAppDispatch } from '../app/hooks';
import { setToken } from '../login/authSlice';
import { useRegisterMutation } from '../app/api/api';

const RegisterSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
  password: Yup.string().required('Required'),
});

export const Register = ({ orderId }: { orderId?: string }) => {
  const dispatch = useAppDispatch();
  const [register] = useRegisterMutation();
  const { getFieldProps, isSubmitting, touched, errors, handleSubmit } =
    useFormik({
      initialValues: {
        email: '',
        password: '',
        orderId: orderId,
      },
      enableReinitialize: true,
      validationSchema: RegisterSchema,
      onSubmit: async (values, { setSubmitting }) => {
        const result = await register(values);
        if ('error' in result) {
          console.error(result.error);
        } else if ('data' in result) {
          //localStorage.setItem('auth_token', result.data.token);
          dispatch(setToken(result.data.token));
        }
        setSubmitting(false);
        dispatch(close());
      },
    });

  return (
    <form onSubmit={handleSubmit}>
      <FormGroup className={styles.email}>
        <label htmlFor="email">Email</label>
        <input type="email" id="email" {...getFieldProps('email')} />
        {touched.email && errors.email ? (
          <ErrorText>{errors.email}</ErrorText>
        ) : null}
      </FormGroup>
      <FormGroup className={styles.password}>
        <label htmlFor="password">Password</label>
        <input type="password" id="password" {...getFieldProps('password')} />
        {touched.password && errors.password ? (
          <ErrorText>{errors.password}</ErrorText>
        ) : null}
      </FormGroup>
      <FormGroup buttons={true}>
        <Button type="submit" disabled={isSubmitting}>
          Register
        </Button>
        <Button
          tier={ButtonTier.Secondary}
          type="button"
          onClick={() => {
            dispatch(close());
          }}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      </FormGroup>
      <FormGroup>
        <Button
          tier={ButtonTier.Quaternary}
          onClick={() => {
            dispatch(
              open({
                title: 'Log in',
                contentKey: ModalContent.Login,
                contentPayload: {
                  redirect: '/account/',
                },
              })
            );
          }}
        >
          Already registered? Login now
        </Button>
      </FormGroup>
    </form>
  );
};
